import Keys39Up from './Keys39Up';
export default function App() { return <Keys39Up />; }
